"use strict";
import React from 'react';
function attachedLabelToTree(treeData) {
    let components = [];
    const getDataNode = function (treeData, container) {
        treeData.forEach(function (treeNode) {

            if (treeNode) {
                let dataNode = {
                    label: <span
                        title={typeof (treeNode.label) === 'string' ? treeNode.label : null} >
                        {treeNode.label}
                    </span>
                }
                if (treeNode._id) {
                    dataNode._id = treeNode._id
                }
                if (treeNode.id) {
                    dataNode.id = treeNode.id
                }
                if (treeNode.initiativeId) {
                    dataNode.initiativeId = treeNode.initiativeId
                }
                if (treeNode.name) {
                    dataNode.name = treeNode.name
                }
                if (treeNode.parent) {
                    dataNode.parent = treeNode.parent
                }
                if (treeNode.value) {
                    dataNode.value = treeNode.value
                }
                if (treeNode.baseCategory) {
                    dataNode.baseCategory = treeNode.baseCategory
                }
                if (treeNode.category) {
                    dataNode.category = treeNode.category
                }
                if (treeNode.subCategory) {
                    dataNode.subCategory = treeNode.subCategory
                }
                if (treeNode.parentOrganizationId) {
                    dataNode.parentOrganizationId = treeNode.parentOrganizationId
                }
                if (treeNode.pathMap) {
                    dataNode.pathMap = treeNode.pathMap
                }
                if (treeNode.breadcrumbs) {
                    dataNode.breadcrumbs = treeNode.breadcrumbs
                }
                if (treeNode.nodes && treeNode.nodes.length) {
                    dataNode.nodes = [];
                    getDataNode(treeNode.nodes, dataNode.nodes)
                }
                container.push(dataNode);
            }
        });
    }
    getDataNode(treeData, components);

    return components
};

export default attachedLabelToTree;